export default __webpack_public_path__ + "static/media/verified_white_24dp.635e47d4.svg";